import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  getSingleCompany,
  updateAvailableModules,
  getAvailableModules,
  createNewCompany,
  updateSubmitModalFinishOpen,
  startRetryCompany,
  startRetryUser,
  startRetryEmployee,
  resetAvailableModules,
  showRollbackModal,
  startRollbackOrganization,
  cancelRollbackModal,
  rollbackFinish,
  startRollbackUser,
  updateCompany,
  updateSubmitModalErrorOpen,
  startRetryUpdateCompany,
  startRetryUpdateUser,
  startRetryUpdateEmployee,
  updateCreateNewCompanyStep,
  resetSubmitModal,
} from '../../redux/actions/company';
import {
  getSingleEmployee,
  getEmployeeRole,
  updateEmployeeRolesAll,
} from '../../redux/actions/employee';

import CompanyRegisterPage from './CompanyRegister.page';

const mapStateToProps = state => ({
  availableModules: state.organization.availableModules,
  availableModulesLoading: state.organization.availableModulesLoading,
  availableModulesError: state.organization.availableModulesError,
  organizationToken: state.auth.organizationToken,
  me: state.auth.me,
  employeeRoles: state.organization.employeeRolesAll,
  submitAddCompanyState: state.organization.submitAddCompanyState,
  submitAddUserState: state.organization.submitAddUserState,
  submitAddEmployeeState: state.organization.submitAddEmployeeState,
  submitModalFinishOpen: state.organization.submitModalFinishOpen,
  submitModalErrorOpen: state.organization.submitModalErrorOpen,
  createNewCompanyParams: state.organization.createNewCompanyParams,
  createNewCompanyStep: state.organization.createNewCompanyStep,
  loadingEmployeeRoles: state.organization.getLoading,
  rollbackModalOpen: state.organization.rollbackModalOpen,
  rollbackModalFinishOpen: state.organization.rollbackModalFinishOpen,
  isRollbackSuccess: state.organization.isRollbackSuccess,
  companyDetails: state.organization.companyDetail,
  employeeDetails: state.organization.detailEmployee,
});

const mapDispatchToProps = {
  getSingleCompany,
  updateAvailableModules,
  getAvailableModules,
  createNewCompany,
  updateSubmitModalFinishOpen,
  startRetryCompany,
  startRetryUser,
  startRetryEmployee,
  resetAvailableModules,
  showRollbackModal,
  startRollbackOrganization,
  cancelRollbackModal,
  rollbackFinish,
  startRollbackUser,
  getSingleEmployee,
  getEmployeeRole,
  updateCompany,
  updateSubmitModalErrorOpen,
  startRetryUpdateCompany,
  startRetryUpdateUser,
  startRetryUpdateEmployee,
  updateCreateNewCompanyStep,
  resetSubmitModal,
  updateEmployeeRolesAll,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyRegisterPage));
